export default [
  'set.adeptRider',
  'set.aetherialAscension',
  'set.alessiasBulwark',
  'set.ancientDragonguard',
  'set.armorMaster',
  'set.armorOfTheSeducer',
  'set.ashenGrip',
  'set.assassinsGuile',
  'set.chimerasRebuke',
  'set.clawOfTheForestWraith',
  'set.cleverAlchemist',
  'set.coldharboursFavorite',
  'set.criticalRiposte',
  'set.daedricTrickery',
  'set.daringCorsair',
  'set.dauntlessCombatant',
  'set.deadlandsDemolisher',
  'set.deathsWind',
  'set.diamondsVictory',
  'set.dragonsAppetite',
  'set.druidsBraid',
  'set.eternalHunt',
  'set.eyesOfMara',
  'set.fortifiedBrass',
  'set.graveStakeCollector',
  'set.heartlandConqueror',
  'set.highlandSentinel',
  'set.histBark',
  'set.histWhisperer',
  'set.hundingsRage',
  'set.innateAxiom',
  'set.ironFlask',
  'set.kagrenacsHope',
  'set.kvatchGladiator',
  'set.lawOfJulianos',
  'set.legacyOfKarth',
  'set.magnusGift',
  'set.mechanicalAcuity',
  'set.mightOfTheLostLegion',
  'set.morkuldin',
  'set.nagaShaman',
  'set.newMoonAcolyte',
  'set.nightMothersGaze',
  'set.nightsSilence',
  'set.noblesConquest',
  'set.nocturnalsFavor',
  'set.oblivionsFoe',
  'set.oldGrowthBrewer',
  'set.ordersWrath',
  'set.orgnumsScales',
  'set.pelinalsWrath',
  'set.redEaglesFury',
  'set.redistributor',
  'set.seekerSynthesis',
  'set.sencheRahtsGrit',
  'set.serpentsDisdain',
  'set.shacklebreaker',
  'set.shalidorsCurse',
  'set.shatteredFate',
  'set.sloadsSemblance',
  'set.songOfLamae',
  'set.spectresEye',
  'set.spellParasite',
  'set.stuhnsFavor',
  'set.tavasFavor',
  'set.telvanniEfficiency',
  'set.tharrikersStrike',
  'set.threadsOfWar',
  'set.torugsPact',
  'set.trialByFire',
  'set.twiceBornStar',
  'set.twilightsEmbrace',
  'set.unchainedAggressor',
  'set.vampiresKiss',
  'set.varensLegacy',
  'set.vastariesTutelage',
  'set.wayOfTheArena',
  'set.whitestrakesRetribution',
  'set.willowsPath',
  'set.wretchedVitality',
];
